// extracted by mini-css-extract-plugin
export default {"container":"highlight_container__7Urwp"};